import type { SVGProps } from 'react';

export const ThumbsDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7.00482C1 8.10939 1.89543 9.00482 3 9.00482H3.5424C3.95454 9.00482 4.32446 9.25768 4.47413 9.64168L6.76471 15.5187C6.87882 15.8115 7.16087 16.0043 7.47511 16.0043C8.31728 16.0043 9 15.3216 9 14.4794V12.0049C9 11.4526 9.44771 11.0049 10 11.0049H10.9968C12.8147 11.0049 14.2149 9.4009 13.9693 7.59964L13.4233 3.59474C13.2206 2.10825 11.951 1 10.4508 1H3C1.89543 1 1 1.89543 1 3V7.00482Z"
        fill="currentColor"
      />
    </svg>
  );
};
